import RenderOnViewportEntry from '@creator/ui/components/RenderOnViewportEntry/RenderOnViewportEntry';
import { cn } from '@creator/ui/utils/ui';
import AdvertisingSlot from '@src/components/Ads/AdvertisingSlot';
import PostList from '@src/components/Post/PostList/PostList';
import type { FC } from 'react';
import { memo } from 'react';

export interface TokenSidebarProps {
    tokenName: string;
    className?: string;
    postId?: string; // in case of post page
    showRecommendedPosts?: boolean;
}

const RECOMMENDED_POSTS_LIMIT = 10;

const TokenSidebar: FC<TokenSidebarProps> = props => {
    const { className, postId, tokenName, showRecommendedPosts } = props;

    function renderAd() {
        return <AdvertisingSlot divIdSufix={postId} className="mx-auto" location="mid_right" playWireLocation="top_right" tokenName={tokenName} />;
    }

    function renderRecommendedPosts() {
        if (!showRecommendedPosts) return null;

        return <PostList postCardCompactProps={{ hideProfileImage: true }} type="recommended" tokenName={tokenName} className="" fetchLimit={RECOMMENDED_POSTS_LIMIT} />;
    }

    return (
        <RenderOnViewportEntry className={cn('space-y-4 p-4 border-l border-gray-200 dark:border-gray-600 ', className)}>
            {renderAd()}
            {renderRecommendedPosts()}
        </RenderOnViewportEntry>
    );
};

export default memo(TokenSidebar);
